var pug = require("!../../../../devtools/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-grafikon\"\u003E\u003Cgrafikon-form init-data=\"$ctrl.initData\" on-form-submit=\"$ctrl.getGrafikon(formModel)\"\u003E\u003C\u002Fgrafikon-form\u003E\u003Cloader ng-show=\"$ctrl.showLoader\"\u003E\u003C\u002Floader\u003E\u003Cgrafikon-megjelenito chart-options=\"$ctrl.chartOptions\" form-model=\"$ctrl.postedFormModel\" ng-if=\"$ctrl.showGrafikon\"\u003E\u003C\u002Fgrafikon-megjelenito\u003E\u003Cdiv ng-show=\"$ctrl.notEnoughData\"\u003EKérem, adjon meg nagyobb intervallumot!\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ../source/application/grafikon-container/grafikon-container/grafikon-container.pug
// module id = 597
// module chunks = 5